import {
  SET_OFFERING_DOCUMENTS,
} from '../../config/mutationTypes';

export default {
  [SET_OFFERING_DOCUMENTS](state, data){
    state.offeringDocuments = data;
  }
};
